namespace GeniuzPOS.Lookups {
    export interface VwpsShopRow {
        Id?: number;
        ShopId?: string;
        ShopTypeId?: string;
        ShopGroupId?: string;
        ShopName?: string;
        BranchName?: string;
        ShopAddress?: string;
        ShopRegName?: string;
        ShopRegAddressLine1?: string;
        ShopRegAddressLine2?: string;
        ShopRegAddressLine3?: string;
        ShopRegId?: string;
        ShopTaxId?: string;
        PromptPayLink?: string;
        QrCodeAccount?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        BranchTaxCode?: string;
        ErpStore?: string;
        ErpChannel?: string;
        Email?: string;
        TelId?: string;
        ShopNameEn?: string;
        BranchNameEn?: string;
        ShopAddressEn?: string;
        ShopBuildingName?: string;
        ShopBuildingNo?: string;
        ShopStreetName?: string;
        ShopDistrict?: string;
        ShopCity?: string;
        ShopProvince?: string;
        ShopPostalCode?: string;
        ShopCountryCode?: string;
        BranchNameDesc?: string;
        BranchNameDescEn?: string;
        ShopBuildingNameEn?: string;
        ShopBuildingNoEn?: string;
        ShopStreetNameEn?: string;
        ShopDistrictEn?: string;
        ShopProvinceEn?: string;
        ShopCityEn?: string;
        ShopFullName?: string;
    }

    export namespace VwpsShopRow {
        export const idProperty = 'ShopId';
        export const nameProperty = 'ShopFullName';
        export const localTextPrefix = 'Lookups.VwpsShop';
        export const lookupKey = 'Lookups.VwpsShop';

        export function getLookup(): Q.Lookup<VwpsShopRow> {
            return Q.getLookup<VwpsShopRow>('Lookups.VwpsShop');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            ShopTypeId = "ShopTypeId",
            ShopGroupId = "ShopGroupId",
            ShopName = "ShopName",
            BranchName = "BranchName",
            ShopAddress = "ShopAddress",
            ShopRegName = "ShopRegName",
            ShopRegAddressLine1 = "ShopRegAddressLine1",
            ShopRegAddressLine2 = "ShopRegAddressLine2",
            ShopRegAddressLine3 = "ShopRegAddressLine3",
            ShopRegId = "ShopRegId",
            ShopTaxId = "ShopTaxId",
            PromptPayLink = "PromptPayLink",
            QrCodeAccount = "QrCodeAccount",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            BranchTaxCode = "BranchTaxCode",
            ErpStore = "ErpStore",
            ErpChannel = "ErpChannel",
            Email = "Email",
            TelId = "TelId",
            ShopNameEn = "ShopNameEn",
            BranchNameEn = "BranchNameEn",
            ShopAddressEn = "ShopAddressEn",
            ShopBuildingName = "ShopBuildingName",
            ShopBuildingNo = "ShopBuildingNo",
            ShopStreetName = "ShopStreetName",
            ShopDistrict = "ShopDistrict",
            ShopCity = "ShopCity",
            ShopProvince = "ShopProvince",
            ShopPostalCode = "ShopPostalCode",
            ShopCountryCode = "ShopCountryCode",
            BranchNameDesc = "BranchNameDesc",
            BranchNameDescEn = "BranchNameDescEn",
            ShopBuildingNameEn = "ShopBuildingNameEn",
            ShopBuildingNoEn = "ShopBuildingNoEn",
            ShopStreetNameEn = "ShopStreetNameEn",
            ShopDistrictEn = "ShopDistrictEn",
            ShopProvinceEn = "ShopProvinceEn",
            ShopCityEn = "ShopCityEn",
            ShopFullName = "ShopFullName"
        }
    }
}
